export default __webpack_public_path__ + "static/data-vis-status-severity-light-04cb975a181c7effcc5734ca09b7d5dcab90832dae3666a19c41ff0578055d48.png";